import styled from "styled-components";

const MyDeliveriesFaqStyled = styled.div`
   max-width: 768px;
`;

export { 
	MyDeliveriesFaqStyled
 };
